<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button type="primary" @click="importVisible=true">{{ $t('CargoMsg.Cargo_Import') }}</el-button>
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>

      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="250314"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="680px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div style="display: flex">
          <el-form label-width="80px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_Warehouse2')" required>
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                no="airportCargoTerminalUuid"
                filterable
                :method-params="{dataType:1, deletionFlag: false}"
                :default-value="editDialog.form.airportCargoTerminalUuid"
                options-width="200px"
                style="width: 200px"
                @parentCallBack="p=>{editDialog.form.airportCargoTerminalUuid=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PalletStatus')" required>
              <el-select v-model="editDialog.form.palletStatus" filterable no="palletStatus">
                <el-option v-for="(item,index) in LOCATION_STATE_LIST" :key="index" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_RecyclingType')" required>
              <el-select v-model="editDialog.form.recycleType" filterable no="recycleType">
                <el-option v-for="(item,index) in RECYCLE_TYPE_LIST" :key="index" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_PalletID')" required>
              <el-input v-model="editDialog.form.palletCode" no="palletCode" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PalletMaterial')" required>
              <el-select v-model="editDialog.form.palletMaterial" filterable clearable no="palletMaterial" style="width: 200px">
                <el-option v-for="(item,index) in TRAY_MATERIAL_LIST" :key="index" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PalletTareWeight')" required>
              <div style="display: flex">
                <auto-number-input
                  v-model="editDialog.form.palletTareWeight"
                  no="palletTareWeight"
                  :enforce-min="true"
                  :precision="0"
                  :min="0"
                  style="width: 180px;"
                />
                <span>KG</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-form label-width="100px" label-position="right">
        <el-form-item :label="$t('CargoMsg.Cargo_RemarksInfo')">
          <el-input v-model="editDialog.form.remarks" type="textarea" :rows="3" no="remarks" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <import-dialog
      :title="$t('CargoMsg.Cargo_Import')"
      :action="URL.mdm.importPalletConfigurationUrl"
      :visible="importVisible"
      folder-name="mdm"
      file-name="PalletConfigurationImport.xls"
      @uploadSuccess="toQuery"
      @onClose="importVisible=false"
    />
  </div>
</template>

<script>
import { getPalletConfigurationList, savePalletConfiguration, delPalletConfiguration
} from '@/api/basicData/palletConfiguration'
import { getLoading } from '@/utils/utilBaseElement'
import { getUuid } from '@/utils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import {
  LOCATION_STATE_LIST, RECYCLE_TYPE_LIST,
  TRAY_MATERIAL_LIST
} from '@/class/cargo/model/parameters/SystemConstants'
import ImportDialog from '@/views/cargo/v0/Information/components/basicData/importDialog.vue'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'PalletConfiguration',
  components: { ImportDialog, AutoNumberInput, cargoAdvanceSelect },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      URL,
      RECYCLE_TYPE_LIST,
      LOCATION_STATE_LIST,
      TRAY_MATERIAL_LIST,
      selectTypeNames: TYPE_NAMES,
      addKey: 'addLocation_',
      total: 0,
      importVisible: false,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirportCode'),
          field: 'airportCode',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseCode2'),
          field: 'warehouseCode',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseName'),
          field: 'warehouseName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PalletID'),
          field: 'palletCode',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PalletStatus'),
          field: 'palletStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, LOCATION_STATE_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PalletMaterial'),
          field: 'palletMaterial',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, TRAY_MATERIAL_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RecyclingType'),
          field: 'recycleType',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, RECYCLE_TYPE_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PalletTareWeight'),
          field: 'palletTareWeight',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RemarksInfo'),
          field: 'remarks',
          width: 150
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          airportCargoTerminalUuid: '',
          palletCode: '',
          palletStatus: 0,
          palletMaterial: '',
          recycleType: 0,
          palletTareWeight: '',
          remarks: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getPalletConfigurationList(self.filter).then(res => {
        syncSpecificBasicData(basicCacheKeys.basic_data_PalletConfiguration)
        self.rowData = res.data.list
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: this.addKey + getUuid(),
          airportCargoTerminalUuid: '',
          palletCode: '',
          palletStatus: 0,
          palletMaterial: '',
          recycleType: 0,
          palletTareWeight: 0,
          remarks: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_PalletConfiguration')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const form = { ...rows[0] }
        this.editDialog.form = form
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_PalletConfiguration')
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (form.uuid && form.uuid.indexOf(this.addKey) !== -1) {
        form.uuid = ''
      }
      const requiredFields = [
        { key: 'airportCargoTerminalUuid', messageKey: 'Cargo_Warehouse2' },
        { key: 'palletCode', messageKey: 'Cargo_PalletID' },
        { key: 'palletMaterial', messageKey: 'Cargo_PalletMaterial' },
        { key: 'palletTareWeight', messageKey: 'Cargo_PalletTareWeight' }
      ]
      for (const field of requiredFields) {
        // 不使用if (form[field.key])原因是因为 他会校验0 托盘数量可以为0 HTTP托盘的code是0
        if (form[field.key] === undefined || form[field.key] === null || form[field.key] === '') {
          self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t(`CargoMsg.${field.messageKey}`))
          return
        }
      }
      const loading = getLoading()
      savePalletConfiguration(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      }).finally(() => loading.close())
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const row = rows.filter(p => p.palletStatus === 2)
      if (row && row.length > 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PalletDeleteTip'))
        return
      }
      self.$confirm(self.$t('CargoMsg.Cargo_DeleteTip1', [rows.length, self.$t('CargoMsg.Cargo_Pallet2')]), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delPalletConfiguration(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    }
  }
}
</script>

<style>
</style>
